import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

export async function subscribeToNewsletter(email, source) {
  const normalizedEmail = email.trim().toLowerCase();

  if (!normalizedEmail) {
    throw new Error('Please enter your email address.');
  }

  // A deterministic ID prevents the same normalized email from being added twice.
  const subscriberId = btoa(encodeURIComponent(normalizedEmail));
  await setDoc(doc(db, 'newsletterSubscribers', subscriberId), {
    email: normalizedEmail,
    source,
    status: 'active',
    subscribedAt: serverTimestamp(),
  });
}
